/* Bundle builder: pool loader and range labelling.

   The eligible frames are fetched from the collection's own products.json in
   pages of 250, because Liquid caps a collection loop at 50 and the 25 KD
   range holds hundreds of frames. Order follows the collection's sort order.

   THE FETCH IS LOCALE-AWARE. products.json served from /collections/... is
   the English catalogue; the Arabic titles live at /ar/collections/... . The
   path here was absolute, so on the Arabic site the builder quietly loaded
   English data and every bundle card read "Freak | أسود" — the colour
   translated because it came from the product title, the family name not,
   because the whole title came from the English endpoint. The product data
   was correct all along; the URL was asking the wrong catalogue.

   window.SF_ROOT is set by Liquid from routes.root_url ('/' or '/ar'). It
   falls back to '' so nothing changes if the snippet is ever absent.

   Sold-out frames are dropped here rather than later, so a shopper can never
   pick one and hit a wall at checkout.

   ALL IMAGES are kept, not just the first. A bundle card is the only view of
   a frame a shopper gets — we deliberately do not send them to the product
   page mid-build — so the card has to show what the product page would: the
   folded shot, the detail, the one on a face.

   Both ids are kept. The variant id goes in the cart; the PRODUCT id is what
   the family grid lists in data-pids, and is how the bundle filters work out
   which family a frame belongs to. */
(function(){
"use strict";
window.SFBundleCache = window.SFBundleCache || {};

/* '/ar' with no trailing slash, or '' on the English site. */
function root(){
  var r = window.SF_ROOT || '';
  return r === '/' ? '' : r.replace(/\/$/, '');
}

window.SFBundlePool = function(handle, onProgress){
  var out=[], page=1, seen=0, dropped=0;
  function step(){
    return fetch(root()+'/collections/'+handle+'/products.json?limit=250&page='+page)
      .then(function(r){ return r.ok ? r.json() : {products:[]} })
      .then(function(j){
        var list=j.products||[];
        seen += list.length;
        list.forEach(function(p){
          var v=(p.variants||[])[0]; if(!v) return;
          if(v.available === false){ dropped++; return }
          var imgs=(p.images||[]).map(function(i){ return i.src }).filter(Boolean);
          out.push({
            id: v.id,
            pid: p.id,
            title: p.title,
            price: Math.round(parseFloat(v.price)*1000),
            img: imgs[0] || '',
            imgs: imgs.slice(0,8),
            /* The product link needs the locale prefix too, or a shopper on
               the Arabic site is dropped onto the English product page. */
            url: root()+'/products/'+p.handle,
            available: true
          });
        });
        if(onProgress) onProgress(out.length);
        if(list.length === 250 && page < 8){ page++; return step() }
        out.seen = seen;
        out.soldOut = dropped;
        window.SFBundleCache[handle] = out;
        return out;
      })
      .catch(function(){ return out });
  }
  return step();
};

window.SFBundleRange = function(b){
  if(b && b.range) return b.range;
  var h=(b&&b.collection)||'';
  var m=h.match(/bundle-range-([0-9]+)/);
  return m ? m[1]+' KD' : 'this';
};
})();